export const getEmailDomain = (email: string) => {
  const emailDomain = email.split('@')[1]
  return emailDomain
}
